import authRules from '../authRules';

const addAssignmentViewSalaryLevel = (user) => {
  const { rsSalaryLevel } = user.securityLevels;
  if (rsSalaryLevel >= authRules.addAssignmentViewSalaryLevel.rsSalaryLevel) {
    return true;
  } else {
    return false;
  }
}

export default addAssignmentViewSalaryLevel;



// WEBPACK FOOTER //
// ./src/AuthLogic/rules/addAssignmentViewSalaryLevel.js